import React, { Component } from 'react';
import Comment from '../../../../common/comments/comment.component';
import { MAX_LENGTH } from '../../../../../constants/external-constants'
import { Loading } from '../../../../common/loading';
import { invoiceCommentActions } from '../../../../../store/external/invoice/invoice/invoice-comments.reducer';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

class InvoiceCommentsComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false
        }

    }

    componentDidMount() {
        const { getInvoiceDetailsComments } = this.props;
        getInvoiceDetailsComments(this.props.invoiceDetailsId, 1)
            .then(() => {
                this.setState({ isLoading: false })
            });
    }

    postComment = async (attachedFilename, attachedFileData, commentDescription) => {
        const { postInvoiceDetailsComments } = this.props;
        await postInvoiceDetailsComments(this.props.invoiceDetailsId, attachedFilename, attachedFileData, commentDescription);
    }

    handleDeleteInvoiceComments = async (invoiceDetailsId) => {
        this.setState({ isLoading: true });
        const { deleteInvoiceDetailsComments, getInvoiceDetailsComments, invoiceInvoiceComments } = this.props;
        await deleteInvoiceDetailsComments(invoiceDetailsId, this.props.invoiceDetailsId);
        this.props.clearInvoiceComments();
        await getInvoiceDetailsComments(this.props.invoiceDetailsId, 1, invoiceInvoiceComments?.InvoiceDetailsComments?.length).then(() => {
            this.setState({ isLoading: false })
        });
        this.setState({ show: false })
    }

    handleLoadMore = async () => {
        const { getInvoiceDetailsComments, invoiceInvoiceComments } = this.props;
        await getInvoiceDetailsComments(this.props.invoiceDetailsId, invoiceInvoiceComments.pageIndex + 1)
    }

    componentWillUnmount() {
        this.props.clearInvoiceComments();
    }

    render() {

        if(this.state.isLoading){
            return <Loading />
        }

        const { roles } = this.props

        return (
            <div>
                <Comment
                    commentList={this.props.invoiceInvoiceComments.InvoiceDetailsComments}
                    addCommentAction={this.postComment.bind(this)}
                    deleteCommentAction={this.handleDeleteInvoiceComments.bind(this)}
                    maxLength={MAX_LENGTH.limit_500}
                    isInvoiceComment={true}
                    handleLoadMore={this.handleLoadMore}
                    hasMoreComments={this.props?.invoiceInvoiceComments.hasMoreComments}
                    {...roles}
                />
            </div>
        );
    }
}


export default connect(
    state => {
        const { invoiceInvoiceComments } = state;
        return {
            invoiceInvoiceComments
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, invoiceCommentActions),
        dispatch
    )
)(InvoiceCommentsComponent);